var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.previewURL,"width":_vm.width,"height":_vm.height},on:{"load":function($event){_vm.imgLoaded=true},"error":function($event){_vm.imgLoaded=false}}},[(!_vm.previewURL || !_vm.imgLoaded)?_c('v-layout',{attrs:{"fill-height":"","align-center":"","justify-center":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v(_vm._s(_vm.previewIcon))])],1):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49d4ec97","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bglayerswitcher/LayerPreviewImage.vue
// module id = Tt3T
// module chunks = 1